import { LoginForm } from "@/components/login-form";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/password/login/")({
  validateSearch: (search) => loginSearchSchema.parse(search),
  component: () => <LoginForm />,
});
